export default {
  es: {
    hero: {
      title1: "SOMOS",
      title2: "luz, gas y mucho más",
    },
    luz: {
      hero: "Luz",
      title: "Te ofrecemos luz...",
      text: "Te ofrecemos distintas tarifas de luz para que elijas la que mejor se ajusta a tu consumo y estilo de vida. Si buscas el mejor precio de la luz o una tarifa de luz estable que te dé tranquilidad mes a mes, estamos aquí para ayudarte y resolver cualquier duda.",
      button: "TARIFAS LUZ",
    },
    gas: {
      hero: "Gas",
      title: "Y también gas...",
      text: "¿Cuánto gas consumes? Tengas la tarifa de gas que tengas nuestro coste de gestión es el mismo para todos. ¡En iner estamos siempre dispuestos a que tu hucha se llene más rápido!",
      button: "TARIFAS GAS",
    },
    autoconsumo: {
      title: "Autoconsumo",
      text: "<p>Nuestras instalaciones incluyen todo lo que necesitas para empezar a ahorrar desde el primer momento, siempre con las mayores marcas y la última tecnología.</p> <p>Realiza la instalación en tu vivienda o comunidad de vecinos desde 3.500€.</p>",
      button: "TARIFAS AUTOCONSUMO",
    },
    aerotermia: {
      title: "Aerotermia",
      text: "En Iner ofrecemos soluciones de aerotermia para climatizar tu hogar o negocio de manera eficiente y sostenible. Nuestra tecnología de aerotermia aprovecha la energía del aire para proporcionar calefacción, refrigeración y agua caliente con un bajo consumo energético. Ahorra en tu factura y reduce tu impacto ambiental con nuestros sistemas de aerotermia de última generación, instalados y mantenidas por profesionales expertas.",
      button: "TARIFAS AEROTERMIA",
    },
    cocheElectrico: {
      hero: "Coche <br> eléctrico",
      title: "Coche eléctrico",
      text: "Impulsa la movilidad eléctrica con los cargadores para coches eléctricos de Iner. Nuestros puntos de recarga son seguros, rápidos y compatibles con la mayoría de vehículos. Puedes usarlos con energía solar mediante autoconsumo para maximizar tu ahorro, o de forma independiente, siempre reduciendo tu factura y apostando por la energía limpia.",
      button: "TARIFAS COCHE ELÉCTRICO",
    },
    muchoMas: {
      title: "Mucho más",
      text: "<p>Además, si ya eres parte de la familia Iner, podrás disfrutar de muchos más servicios para tu hogar. Soluciones pensadas para hacerte la vida más fácil y ayudarte a ahorrar cada mes.</p> <p>Descubre todo lo que podemos ofrecerte más allá de la luz y gas.</p>",
      button: "OTROS SERVICIOS",
    },
    ademas: {
      title1: "ADEMÁS",
      title2: "te ofrecemos",
      queNoTeMuevasDelSofa: {
        title: "QUE NO TE MUEVAS DEL SOFÁ",
        text: "Llega la hora de despreocuparse. En Iner te aconsejaremos sobre todo aquello relacionado con tu factura de luz o factura de gas para que siempre tengas la mejor opción y por supuesto la que te permita ahorrar más.",
      },
      queNoRecibasSorpresas: {
        title: "Que no recibas sorpresas",
        text: "Sin letra pequeña ni cambios ni sorpresas de última hora... (¡y si tienes sorpresas que sean solo para algo muyyyyy bueno).",
      },
      inergizarte: {
        title: "INERGIZARTE",
        text: "Inergizarse consiste en dedicar toda la energía a las cosas que de verdad importan, como cuidar de los tuyos, disfrutar con los amig@s, viajar, sacar adelante tu negocio, practicar o ver tu deporte favorito, la feria de Albacete... y de lo demás ya nos encargamos nosotros.",
      },
      queTeConviertas: {
        title: "Que te conviertas en un iner",
        text: "¿Qué es un iner? Un iner es una persona de cualquier edad y de cualquier lugar que aprecia por encima de todo ser libre. Libre para cambiar de compañía cuando quiera, para cambiar de tarifas, para llamar cuando quiera a su agente de iner si tiene una pregunta, para gastarse sus ahorros en lo que quiere...",
      },
    },
    teLlamamos: {
      title: "¿Te llamamos?",
      text: "Si tienes alguna consulta, necesitas que te aconsejemos en la elección de tu tarifa de luz o de gas, o simplemente quieres ser un iner desde hoy mismo. ¡Déjanos tu teléfono que te llamamos ya mismo!",
      placeholder: "Escribe aquí tu teléfono...",
      button: "LLÁMAME",
      link: "Date de alta llamando gratis al 900 848 402",
    },
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/que-ofrecemos.js